export enum CreateSessionError {
  UnknownError,
  CountryCodeNotSupported,
  PhoneNumberInvalid,
  PhoneNumberNotVerified,
  CallingDisabled,
  InsufficientMinutes,
  InsufficientTier,
  RecipientInsufficientTier,
  NoLineAvailable,
  BadRequest = 400,
  InternalServerError = 500,
  CallInProgress = 80208
}